export default "__VITE_ASSET__Ds6Lvtbl__"